import { PATIENT_SERVICES } from '@avanta/shared/constants/patients';
import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { TrainingCalendar } from 'components/TrainingCalendar';
import { ROUTES } from 'constants/routes';
import { WellbeingTypes } from 'constants/wellbeing';
import { useNavRedirect } from 'hooks/useNavRedirect';
import { useWellbeingContent } from 'hooks/useWellbeingContent';
import { useUserStore } from 'stores/user';
import { BarometerResults } from './components/BarometerResults';
import { ChatBanner } from './components/ChatBanner';
import { NPSSurvey } from './components/NPSSurvey';
import { PaeHero } from './components/PaeHero';
import { ReferralCard } from './components/ReferralCard';
import { SuggestedContent } from './components/SuggestedContent';
import { getRandomElements } from './utils';

export const Pae = (): React.ReactElement => {
  const { pathname } = useLocation();
  const activeServices = useUserStore(state => state.user?.activeServices);
  const { data: trainingsList } = useWellbeingContent(WellbeingTypes.trainings);
  const { data: tipsList } = useWellbeingContent(WellbeingTypes.tips);

  const suggestedList = useMemo(() => {
    const allContent = [...(trainingsList ?? []), ...(tipsList ?? [])];
    return getRandomElements(allContent, 12);
  }, [trainingsList, tipsList]);

  useNavRedirect(pathname === ROUTES.PAE && !activeServices?.includes(PATIENT_SERVICES.PAE));

  return (
    <div className="mb-10 flex flex-col gap-10 px-4.5 am-md:mb-18 am-3xl:gap-18 am-3xl:px-0">
      <PaeHero />
      <div className="mx-auto w-full max-w-7xl">
        <div className="flex flex-col gap-10 am-md:mx-15 am-3xl:gap-18">
          <ChatBanner />
          <NPSSurvey />
          <TrainingCalendar />
          <BarometerResults />
          <SuggestedContent suggestedList={suggestedList} />
          <ReferralCard />
        </div>
      </div>
    </div>
  );
};
